import React, { useState } from 'react';
import PropTypes from 'prop-types';

import {
  Loading,
  Text,
  EmptyState,
  AdditionalModal
} from 'components/common/Elements/Elements';

import AdditionalContent from '../../parts/AdditionalContent/AdditionalContent';

import Os from '../Os/Os';

import { upFirstLetter } from 'utils/common';

import classes from './TableWidget.module.scss';

const TableWidget = ({ data = [], loader }) => {
  const [isOpenAdditional, setIsOpenAdditional] = useState(false);
  const [infoForAdditionalModal, setInfoForAdditionalModal] = useState(false);

  const openModal = rule => {
    setIsOpenAdditional(true);
    setInfoForAdditionalModal({
      content: <AdditionalContent data={rule} />
    });
  };

  return (
    <>
      {isOpenAdditional && (
        <AdditionalModal
          isOpen={isOpenAdditional}
          setIsOpen={setIsOpenAdditional}
          info={infoForAdditionalModal}
        />
      )}
      <table className={classes.table}>
        <thead>
          <tr className={classes.tr}>
            <th className={classes.th}>
              <Text weight={'m'} size={6} className={classes.field}>
                Priority
              </Text>
            </th>
            <th className={classes.th}>
              <Text weight={'m'} size={6} className={classes.field}>
                Profile Name
              </Text>
            </th>
            <th className={classes.th}>
              <Text weight={'m'} size={6} className={classes.field}>
                Operating systems
              </Text>
            </th>
            <th className={classes.th}>
              <Text weight={'m'} size={6} className={classes.field}>
                Groups
              </Text>
            </th>
            <th className={classes.th}>
              <Text weight={'m'} size={6} className={classes.field}>
                Runtime Schedule
              </Text>
            </th>
          </tr>
        </thead>
        <tbody>
          {data.length > 0 &&
            data.map((rule, index) => (
              <tr
                className={classes.trWrap}
                key={index}
                onClick={() => {
                  openModal(rule);
                }}
              >
                <td className={classes.tdBody}>
                  <Text size={6}>{rule.position}</Text>
                </td>
                <td className={classes.tdBody}>
                  <Text>{rule.name}</Text>
                </td>
                <td className={classes.tdBody}>
                  <div className={classes.osWrap}>
                    {rule.platforms.map((item, index) => (
                      <Os key={index} os={upFirstLetter(item.platform_type)} />
                    ))}
                  </div>
                </td>
                <td className={classes.tdBody}>
                  <div className={classes.osWrap}>
                    {rule.assignedTo.map((item, index) => (
                      <Text key={index} className={classes.group}>{`${item}${
                        rule.assignedTo.length - 1 !== index ? ',' : ''
                      }`}</Text>
                    ))}
                  </div>
                </td>
                <td className={classes.tdBody}>
                  <div className={classes.osWrap}>
                    <Text>
                      {upFirstLetter(rule.runAt.type)}
                      {rule.runAt.interval
                        ? ` (${rule.runAt.interval / 60} min)`
                        : ''}
                    </Text>
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      {loader ? <Loading /> : data.length === 0 && <EmptyState />}
    </>
  );
};

TableWidget.propTypes = {
  loader: PropTypes.bool,
  data: PropTypes.array
};

export default TableWidget;
